import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { YearService } from '@masar/core/services';

@Component({
    selector: 'app-year-dropdown',
    templateUrl: './year-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class YearDropdownComponent implements OnInit {
    @Input() public yearLoader!: () => Observable<number[]>;
    @Output() public yearChange = new EventEmitter<number | null>();

    public years?: number[];
    public selectedYear: number | null = null;

    public constructor(private readonly yearService: YearService) {}

    public ngOnInit(): void {
        this.yearLoader()
            .pipe(take(1))
            .subscribe(years => {
                this.years = years;
                if (!years.length) {
                    this.selectedYear = null;
                    this.yearChange.emit(null);
                    return;
                }

                this.selectedYear = this.pickDefaultYear(years);
                this.yearChange.emit(this.selectedYear);
            });
    }

    public onYearSelected(): void {
        if (this.selectedYear != null) {
            this.yearChange.emit(this.selectedYear);
        }
    }

    private pickDefaultYear(years: number[]): number {
        const globalYear = this.yearService.get();
        if (years.includes(globalYear)) {
            return globalYear;
        }

        const now = new Date().getFullYear();
        const pastYears = years.filter(year => year <= now);
        return pastYears.length ? Math.max(...pastYears) : Math.min(...years);
    }
}
